module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "special-content"
  }, [_c('transition', {
    attrs: {
      "name": "special-index"
    }
  }, [(!_vm.is_change_type) ? _c('div', {
    staticClass: "special-index c-thumb-index"
  }, _vm._l((_vm.filtered_special_list), function(item, index) {
    return _c('thumb-index-item', {
      key: index,
      attrs: {
        "item": item,
        "link": item.url,
        "append_class": _vm.append_class
      }
    })
  })) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99501786"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/special/special-content.vue
// module id = 58
// module chunks = 0